import { useHistory } from "react-router-dom";
import { Trans } from "react-i18next";
import { Menu, NavMenu, NavMenuItem } from "@weezevent/nacre";
import { CAPACITIES } from "../../constants/capacities";
import React from "react";
import PropTypes from "prop-types";
import { useAllUserCapacities } from "utils/rights";

export function MenuEventConfig({ organizationId, eventId }) {
	const history = useHistory();
	const userCapacities = useAllUserCapacities(organizationId);

	if (!organizationId || !eventId) {
		return [];
	}
	const capacities = [
		CAPACITIES.ACCESS_MATRIX.MANAGE,
		CAPACITIES.EVENT_CONFIG.READ,
		CAPACITIES.EVENT_CONFIG.MANAGE,
		CAPACITIES.DEFAULT.ADMIN,
		CAPACITIES.DEFAULT.OWNER,
		CAPACITIES.CHECKLIST.READ,
		CAPACITIES.CHECKLIST.EDIT,
		CAPACITIES.PARTNER.ADVANCED_CONFIG,
		CAPACITIES.ZONE.READ,
		CAPACITIES.ZONE.MANAGE,
		CAPACITIES.POPULATION.READ,
		CAPACITIES.POPULATION.MANAGE
	];

	const path = `/access/O${organizationId}/E${eventId}`;

	return (
		<Menu useNew alternative history={history} capacities={userCapacities}>
			<NavMenu allowedCapacities={capacities}>
				<NavMenuItem
					icon="calendar"
					to={`${path}/informations`}
					allowedCapacities={capacities}
				>
					<Trans i18nKey="access.menus.eventConfigs.event" />
				</NavMenuItem>
			</NavMenu>
			<NavMenu
				allowedCapacities={[
					CAPACITIES.PERIOD.MANAGE,
					CAPACITIES.PERIOD.READ
				]}
			>
				<NavMenuItem
					icon="time"
					to={`${path}/periods/`}
					allowedCapacities={[
						CAPACITIES.PERIOD.MANAGE,
						CAPACITIES.PERIOD.READ
					]}
				>
					<Trans i18nKey="access.menus.eventConfigs.periods" />
				</NavMenuItem>
			</NavMenu>
			<NavMenu
				allowedCapacities={[
					CAPACITIES.ZONE.MANAGE,
					CAPACITIES.ZONE.READ
				]}
			>
				<NavMenuItem
					icon="map-pin"
					to={`${path}/zones`}
					allowedCapacities={[
						CAPACITIES.ZONE.MANAGE,
						CAPACITIES.ZONE.READ
					]}
				>
					<Trans i18nKey="access.menus.eventConfigs.zones" />
				</NavMenuItem>
			</NavMenu>
			<NavMenu
				allowedCapacities={[
					CAPACITIES.POPULATION.MANAGE,
					CAPACITIES.POPULATION.READ
				]}
			>
				<NavMenuItem
					icon="group"
					to={`${path}/populations`}
					allowedCapacities={[
						CAPACITIES.POPULATION.MANAGE,
						CAPACITIES.POPULATION.READ
					]}
				>
					<Trans i18nKey={"access.menus.eventConfigs.populations"} />
				</NavMenuItem>
			</NavMenu>
			<NavMenu>
				<NavMenuItem
					icon="list"
					to={`${path}/checkpoints`}
					allowedCapacities={[
						CAPACITIES.EVENT_CONFIG.MANAGE,
						CAPACITIES.DEFAULT.ADMIN,
						CAPACITIES.DEFAULT.OWNER,
						CAPACITIES.CHECKLIST.READ,
						CAPACITIES.CHECKLIST.EDIT
					]}
				>
					<Trans i18nKey={"access.checkpoint.checkpointPlural"} />
				</NavMenuItem>
			</NavMenu>
			<NavMenu
				allowedCapacities={[
					CAPACITIES.ATTENDEES.RO,
					CAPACITIES.ATTENDEES.MANAGE
				]}
			>
				<NavMenuItem
					icon="id-card"
					to={`${path}/attendees`}
					allowedCapacities={[
						CAPACITIES.ATTENDEES.RO,
						CAPACITIES.ATTENDEES.MANAGE
					]}
				>
					<Trans i18nKey="access.menus.attendees" />
				</NavMenuItem>
			</NavMenu>
			<NavMenu>
				<NavMenuItem
					icon="user"
					to={`${path}/partners`}
					allowedCapacities={[
						CAPACITIES.EVENT_CONFIG.MANAGE,
						CAPACITIES.DEFAULT.ADMIN,
						CAPACITIES.DEFAULT.OWNER,
						CAPACITIES.PARTNER.ADVANCED_CONFIG
					]}
				>
					<Trans i18nKey={"access.menus.partners"} />
				</NavMenuItem>
			</NavMenu>
			<NavMenu>
				<NavMenuItem
					icon="diaporama"
					to={`${path}/access-matrix`}
					allowedCapacities={[
						CAPACITIES.ACCESS_MATRIX.MANAGE,
						CAPACITIES.ACCESS_MATRIX.READ
					]}
				>
					<Trans i18nKey={"access.menus.eventConfigs.accessMatrix"} />
				</NavMenuItem>
			</NavMenu>
		</Menu>
	);
}

MenuEventConfig.propTypes = {
	organizationId: PropTypes.number.isRequired,
	eventId: PropTypes.number.isRequired
};
